import type { CallbackInterface } from "recoil";

import { logAppError } from "Helpers/logger";

import type { PageStateType } from "Types/state";

import { errorUpdater, loaderUpdater, pageState } from "State/page";

import { modalEngagementUpsellingState } from "Pages/RecipientsOverview/recoil/state/modalEngagementUpselling";

import {
  getUserEmail,
  notifyEngagementUpsellingContactSendSuccess,
  sendContactRequest,
} from "Pages/RecipientsOverview/recoil/services/modalEngagementUpselling";

export const modalEngagementUpsellingOpenCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    const email = await getUserEmail();

    set(modalEngagementUpsellingState, (prev) => ({
      ...prev,
      email,
      show: true,
    }));
  };

export const modalEngagementUpsellingChangeCallback =
  ({ set }: CallbackInterface) =>
  async (email: string) => {
    set(modalEngagementUpsellingState, (prev) => ({
      ...prev,
      email,
      isDirty: true,
    }));
  };

export const modalEngagementUpsellingCancelCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalEngagementUpsellingState);
  };

export const modalEngagementUpsellingConfirmCallback =
  ({ set, snapshot, reset }: CallbackInterface) =>
  async () => {
    set(pageState, loaderUpdater(true));

    const { email } = await snapshot.getPromise(modalEngagementUpsellingState);

    try {
      await sendContactRequest(email);

      notifyEngagementUpsellingContactSendSuccess();
    } catch (error) {
      logAppError({
        Component: "RecipientsOverview",
        Method: "modalEngagementUpsellingConfirmCallback",
        appError: error,
      });

      set<PageStateType>(pageState, errorUpdater);
    }

    reset(modalEngagementUpsellingState);

    set(pageState, loaderUpdater(false));
  };
